import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RegulatorConfig, RegulatorConfigService } from '../tokens/regulator-config.token';
import { API_PATHS } from '../config/api-paths';

/**
 * REST-only implementation of `RegulatorConfigService`.
 *
 * Calls GET / PUT /services/embedded/api/master-admin/regulator-config via HttpClient.
 * Rule 07 / Rule 10 — no mock fallback. Playwright tests intercept via `page.route()`.
 *
 * Authority required: ROLE_MASTER_ADMIN (enforced server-side and by roleGuard on the route).
 */
@Injectable()
export class RegulatorConfigRestService implements RegulatorConfigService {
  private readonly http = inject(HttpClient);

  get(): Observable<RegulatorConfig> {
    return this.http.get<RegulatorConfig>(API_PATHS.REGULATOR_CONFIG);
  }

  update(config: RegulatorConfig): Observable<RegulatorConfig> {
    return this.http.put<RegulatorConfig>(API_PATHS.REGULATOR_CONFIG, config);
  }
}
